import { EmailButtons, Price } from '../../../../components'
import {
  Box,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@elphasecure/elpha-design-system'

const Confirmation = ({
  isLoading,
  paymentData,
  legalEntityName,
  licenseAmount,
}) => {
  const Icon = ({ enabled, number }) => {
    return (
      <ListItemIcon sx={{ minWidth: '2.8rem', paddingTop: '0.3rem' }}>
        <Box
          component="span"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '2.0rem',
            height: '2.0rem',
            borderRadius: '9999px',

            backgroundColor: enabled ? 'success.main' : 'error.main',
          }}
        >
          <Box sx={{ paddingBottom: '0.2rem', paddingRight: '0.1rem' }}>
            <Typography
              sx={{
                fontWeight: '700',
                fontSize: '1.2rem',
                lineHeight: '1.2rem',
                alignSelf: 'center',
              }}
            >
              {number}
            </Typography>
          </Box>
        </Box>
      </ListItemIcon>
    )
  }

  const copiesForChecklist = [
    'Open your email invite to create an Elpha Secure account.',
    'Send invites to all your teammates from the Elpha Secure dashboard.',
    'Follow the onboarding steps to install your cybersecurity software.',
  ]

  return (
    <>
      <Box sx={{ marginBottom: '5.6rem', textAlign: 'center' }}>
        <Stack>
          {!isLoading && (
            <Stack>
              <Typography
                component="h2"
                variant="bodyXLarge"
                sx={{
                  color: 'primary.600',
                  fontWeight: '400',
                }}
              >
                {licenseAmount} Licenses for {legalEntityName}
              </Typography>
              <Box sx={{ marginTop: '1.2rem' }}>
                {paymentData?.gross_cost && (
                  <Price amount={paymentData?.gross_cost} term="year" />
                )}
              </Box>
            </Stack>
          )}
        </Stack>
      </Box>
      <Box sx={{ textAlign: 'center' }}>
        <Typography
          variant="bodyXLarge"
          component="h2"
          sx={{
            fontWeight: '400',
            color: 'primary.600',
            marginBottom: '2.0rem',
          }}
        >
          Here's what comes next for Elpha Secure software users
        </Typography>
        <Stack direction="row" spacing="8.0rem" sx={{ marginBottom: '4.0rem' }}>
          {copiesForChecklist.map((copy, idx) => {
            return (
              <ListItem disableGutters sx={{ paddingY: 0 }}>
                <ListItemText
                  sx={{
                    width: '25.1rem',
                  }}
                  primary={
                    <Stack direction={'row'}>
                      <Icon enabled={true} number={idx + 1} />
                      <Typography
                        variant="bodyMedium"
                        sx={{
                          color: 'primary.400',
                          width: '25.1rem',
                          lineHeight: '2.4rem',
                        }}
                      >
                        {copy}
                      </Typography>
                    </Stack>
                  }
                />
              </ListItem>
            )
          })}
        </Stack>
      </Box>
      <EmailButtons />
    </>
  )
}

export default Confirmation
